const isIOS = () =>
  typeof window !== undefined &&
  window.navigator &&
  /iPad|iPhone|iPod/.test(window.navigator.userAgent) &&
  !window.MSStream;

export function loginVisibleCSSAppend() {
  document.body.classList.add('cp-apps-login-visible');
  document.body.classList.add('cp-apps-login-body-no-scroll');

  if (isIOS()) {
    document.body.classList.add('cp-apps-login-body-no-scroll--ios');
  }
}

export function loginVisibleCSSRemove() {
  document.body.classList.remove('cp-apps-login-visible');
  document.body.classList.remove('cp-apps-login-body-no-scroll');

  if (isIOS()) {
    document.body.classList.remove('cp-apps-login-body-no-scroll--ios');
  }
}
